export default __webpack_public_path__ + "static/media/yf.fe2f15a2.png";